// extracted by mini-css-extract-plugin
export default {"ctaSection":"CTASection_ctaSection__2fuQS","ctaContent":"CTASection_ctaContent__79WI9","ctaButtons":"CTASection_ctaButtons__mQ6mA"};